import { ResolvedUrl } from '@wearejh/m2-pwa-engine/lib/utils/resolve';

const serverResolvedUrlCookieName = 'server_resolved_url';

function getCookie(name: string): string | undefined {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
        return parts.pop()?.split(';').shift();
    }

    return undefined;
}

export function setResolvedUrlCookie(response, resolvedUrl: ResolvedUrl) {
    try {
        const resolvedUrlData = JSON.stringify(resolvedUrl);

        response.cookie(serverResolvedUrlCookieName, resolvedUrlData, {
            maxAge: 300000, // 5 minutes in milliseconds
            httpOnly: false,
        });
    } catch (error) {
        console.error('A failure occurred setting the urlResolved cookie: ', response.url, error);
    }
}

export function getResolvedUrlCookie(): ResolvedUrl | undefined {
    let serverResolvedUrl: ResolvedUrl | undefined;

    try {
        const cookieData = getCookie(serverResolvedUrlCookieName);

        if (cookieData) {
            const decodedCookieData = decodeURIComponent(cookieData);
            serverResolvedUrl = JSON.parse(decodedCookieData);
        }
    } catch (e) {
        console.error('Error parsing resolved URL cookie', e);
    }

    return serverResolvedUrl;
}
